import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { PostsService } from "./posts.service";
import { PostTranslation } from "../shared/translation.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

@Component({
  selector: "edit-post",
  template: require('./createpost.component.html'),
  styles: [require('./createpost.component.scss')]
})
export class EditPostComponent implements OnInit {
  post: any;
  postTypes: any[] = this.service.getPostTypes();
  languages: any[] = this.service.getLanguages();
  translations: any[] = [];
  sent: boolean = false;
  activePanels: string[] = ["visibility"];
  editMode: boolean = true;
  @ViewChild("modalTemplate") private modalComponent: TemplateRef<any>;
  dialog: NgbModalRef;

  constructor(
    private service: PostsService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    this.post = PostsService.currentPost;
    if (this.post) {
      this.translations = this.getTranslations();
    } else {
      this.router.navigate(["/posts"]);
    }
  }

  getTranslations(): any[] {
    let translationList = [];
    Object.keys(this.post.data.content).map((key, index) => {
      let it = this.post.data.content[key];
      let t = new PostTranslation();
      t.language = key;
      t.author = it.author;
      t.post_details = it.post_details;
      t.post_summary = it.post_summary;
      t.subtitle = it.subtitle;
      t.title = it.title;
      translationList.push(t);
      this.activePanels.push("translations" + (translationList.length - 1));
    });
    return translationList;
  }

  addTranslation() {
    this.translations.push(new PostTranslation());
    this.activePanels.push("translations" + (this.translations.length - 1));
  }

  deleteTranslation(item: any) {
    let index = this.translations.indexOf(item);
    if (index > -1) {
      this.translations.splice(index, 1);
    }
    this.activePanels.splice(this.activePanels.length - 1, 1);
  }

  getPanelTitle(translation: PostTranslation, first: boolean) {
    let text;
    let selectedLang = this.languages.filter((language: any) => {
      return language.key === translation.language;
    })[0];
    text =
      selectedLang && selectedLang.value
        ? selectedLang.value
        : "Choose a language";
    if (first) {
      text += " (Default)";
    }
    return text;
  }

  setDefault(index: number) {
    let t = this.translations[0];
    this.translations[0] = this.translations[index];
    this.translations[index] = t;
  }

  showModal() {
    if (!this.sent) {
      this.dialog = this.modalService.open(this.modalComponent);
    }
  }

  deletePost(result) {
    this.dialog.close();
    if (result) {
      this.sent = true;
      this.service.deletePost(this.post.id).subscribe(
        (res) => {
          this.back();
        },
        (error) => {
          this.sent = false;
        }
      );
    }
  }

  onSubmit() {
    this.activePanels = [];
    setTimeout(() => {
      this.save();
    }, 1);
  }

  save() {
    if (!this.sent) {
      this.sent = true;
      let defLang;
      this.post.data.content = {};
      this.translations.map((it: any) => {
        if (it.language !== "") {
          if (!defLang) {
            defLang = it.language;
          }
          this.post.data.content[it.language] = {
            title: it.title,
            author: it.author
          };
          if (this.post.type === "info") {
            this.post.data.content[it.language].subtitle = it.subtitle;
          } else if (this.post.type === "info-detailed") {
            this.post.data.content[it.language].post_summary = it.post_summary;
            this.post.data.content[it.language].post_details = it.post_details;
          }
        }
      });
      this.post.data.default_lang = defLang;
      let postCopy = Object.assign({}, this.post);
      delete postCopy.context.employerNames;
      delete postCopy.context.projectNames;
      delete postCopy.data.properties;
      this.service.editPost(postCopy).subscribe(
        (response) => {
          this.sent = false;
          this.back();
        },
        (error) => {
          this.activePanels = ["visibility"];
          this.translations.map((it, index) => {
            this.activePanels.push("translations" + index);
          });
          this.sent = false;
        }
      );
    }
  }

  back() {
    window.history.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/posts/editpost.component.ts